export enum ConversationListType {
	INBOX = 'INBOX',
	SENT = 'SENT',
}
